// no itx for this file
import { showToast } from "../components/Toasts";
import { isDevelopmentEnvironment } from "../estada-config";
import KnxProductData from "../KnxProductdata";
import Logger from "../Logger";
import Channel from "../models/Channel";
import { KnxSceneBehaviour, KnxSceneInfo } from "../models/KnxSceneInfo";
import RawSceneDataItem from "../models/RawSceneDataItem";
import { sortArrayByIntProperty } from "../models/utils";
import { changeLanguage } from "../translationItx/itx";
import { isTypeRestriction } from "../Types";
const logger = new Logger();

class GroupItem {
  name: string = "";
  index: number = -1;
  pattern: string = "";
  count: number = 1;
}

export class KnxBuildSceneInfos {
  knxProductData: KnxProductData;

  constructor(knxProductData: KnxProductData) {
    this.knxProductData = knxProductData;
  }

  deref(item: any): any | undefined {
    return this.knxProductData.deref(item);
  }

  getParameterGroups(items: Array<any>): Array<GroupItem> {
    const names = new Array<string>();
    items.map((item) => {
      const derefItem = this.deref(item);
      if (derefItem) {
        const n = this.deref(item)?.a?.Name;
        names.push(n);
      } else {
        logger.error("derefItem == undefined");
      }
    });

    var groups = new Array<GroupItem>();

    function addGroup(name: string, index: number) {
      for (let j = 0; j < groups.length; j++) {
        const name2 = groups[j].name;

        const p = KnxBuildSceneInfos.isSimilar(name, name2);
        if (p == -2 || (p >= 0 && p == groups[j].index)) {
          // pattern already registered
          groups[j].count++;
          return;
        }
      }

      const pattern = name.substring(0, index) + "*" + name.substring(index + 1);
      groups.push({ name: name, index: index, pattern: pattern, count: 1 });
    }

    for (let i = 0; i < names.length - 1; i++) {
      const name1 = names[i];
      for (let j = i + 1; j < names.length; j++) {
        const name2 = names[j];

        const p = KnxBuildSceneInfos.isSimilar(name1, name2);
        if (p >= 0) {
          addGroup(name1, p);
        }
      }
    }

    //
    // we expect that a least 3 Scenes are availible at once
    // 3 Scenes is the minimum found so far for ABB SD/S4.16.1
    //

    groups = groups.filter((a) => a.count >= 3);

    logger.log("getParameterGroups done", groups);
    return groups;
  }

  static isSimilar(name1: string, name2: string): number {
    var firstDiff = -2; // result for "full equal"

    if (name1 && name2) {
      if (name1.length == name2.length) {
        const l = name1.length;
        for (let i = 0; i < l; i++) {
          const c1 = name1.at(i);
          const c2 = name2.at(i);
          if (c1 != c2) {
            if (firstDiff >= 0) {
              return -1;
            }
            firstDiff = i;
          }
        }
      } else {
        return -1;
      }
    } else {
      logger.error("name1 or name2 == undefined");
    }

    return firstDiff;
  }

  isSceneActivationItem(item: unknown): boolean {
    const derefItem = this.deref(item);

    var nameAndText: string = derefItem.a.Name + derefItem.a.Text;
    const text: string = derefItem.a.Text.toLocaleLowerCase();

    nameAndText = nameAndText.toLocaleLowerCase();

    const PT = this.deref((item as any)?.a?.ParameterType);
    const isBoolean = PT.items?.at(0)?.a?.SizeInBit == "1";
    if (isBoolean) {
      switch (this.knxProductData.productInfo.ManufacturerId) {
        // MDT
        case "M-0083":
          return (
            nameAndText.includes("enable") ||
            nameAndText.includes("select") ||
            nameAndText.match("s[zc]ene[a-zA-Z0-9]") != undefined
          );

        case "M-0002":
          return (
            nameAndText.includes("enable") ||
            (nameAndText.includes("assign") &&
              !nameAndText.includes("usescene")));


        default:
          return (text.match("s[zc]ene") != undefined);
      }

      return false;
    }

    const innerType = PT.items[0];
    const isTR = isTypeRestriction(innerType);
    if (isTR) {
      return innerType.items.some((e) => e.a.Text.match("[Ss][zc]ene")) || innerType.items.length == 2;
    }

    return false;
  }

  skipNonGroupItems(s: number, groups: Array<GroupItem>, rawSceneData: Array<any>): number {
    if (s >= rawSceneData.length) {
      return s;
    }

    var item = rawSceneData[s];
    var name = this.deref(item).a.Name;

    function isSimilarToAnyGroup(name: string) {
      for (let j = 0; j < groups.length; j++) {
        const name2 = groups[j].name;

        const p = KnxBuildSceneInfos.isSimilar(name, name2);
        if (p == -2 || (p >= 0 && p == groups[j].index)) {
          return true;
        }
      }

      return false;
    }

    while (s < rawSceneData.length && !isSimilarToAnyGroup(name)) {
      s++;
      item = rawSceneData[s];
      name = this.deref(item).a.Name;
    }

    return s;
  }



  //
  // 1. Find Scene Number Items
  //
  // Scene Number-Items are easy to identify,
  // as they are the only items with a value of about 64 enums
  //
  findSceneNumberItemIndexes(rawSceneData: Array<RawSceneDataItem>): Array<number> {
    var sceneNumberItemIndexes = new Array<number>();

    for (let i = 0; i < rawSceneData.length; i++) {
      const item = rawSceneData[i];
      if (this.knxProductData?.isSceneNumberItem(item)) {
        sceneNumberItemIndexes.push(i);
      }
    }

    return sceneNumberItemIndexes;
  }


  //
  // 2. Find Scene Activation Items
  // if SceneNumberItems are found AND SceneNumbers dont have an enumType with a value of 0< or >64 for disabling the scene
  // we may have SceneActivationItems 1 entry before the SceneNumberItem
  //
  findSceneActivationIndexes(rawSceneData: Array<RawSceneDataItem>, start): Array<number> {
    var sceneActivationIndexes = new Array<number>();

    for (let i = start; i < rawSceneData.length; i++) {
      const item = rawSceneData[i];
      if (this.isSceneActivationItem(item)) {
        sceneActivationIndexes.push(i);
      }
    }

    return sceneActivationIndexes;
  }



  attachBehavioursToSceneInfo(sceneInfo: KnxSceneInfo, rawSceneData: Array<RawSceneDataItem>, start: number, end: number) {
    for (let b = start; b <= end; b++) {
      const item = rawSceneData[b];

      // otherwise, we assume a scene property

      const sceneBehaviour = new KnxSceneBehaviour();
      sceneBehaviour.instanceId = item.instanceId;
      sceneBehaviour.moduleId = item.moduleId;
      sceneBehaviour.name = this.deref(item).a.Name;
      sceneBehaviour.parameterId = item.id;
      sceneBehaviour.label = this.knxProductData.getTranslatedProperty("Text", this.deref(item));
      sceneBehaviour.data = item;

      sceneInfo.behaviours.push(sceneBehaviour);
    }
  }

  findOutlierWithSystematicPattern(strings: string[]): number | undefined {
    if (strings.length < 3) return undefined;

    const lengthArray = new Map<number, Set<number>>();

    for (let index = 0; index < strings.length; index++) {
      const s = strings[index];
      if (s.length > 0) {
        let ll = lengthArray.get(s.length);
        if (!ll) {
          ll = new Set<number>();
          lengthArray.set(s.length, ll);

        }
        ll.add(index)
      }
    }

    // Prüfen ob e eine Länge nur einmal gibt.
    // Wenn ja, dann ist der String mit dieser Länge der Ausreißer
    //

    let res: undefined | number = undefined;


    let minStringLength = Number.MAX_SAFE_INTEGER;
    for (const [index, value] of lengthArray) {
      // Wenn es nur einen Eintrag gibt, dann ist das der Ausreißer
      if (value.size == 1) {
        return value.values().next().value; // den Index des Ausreißers zurückgeben
      } else {
        if (minStringLength > index) {
          minStringLength = index;
        }
      }
    }

    const len = minStringLength;

    const n = strings.length;
    const positionCodes: number[][] = [];

    // Zeichenweise CharCodes erfassen
    for (let i = 0; i < len; i++) {
      positionCodes.push(strings.map(s => s[i].charCodeAt(0)));
    }

    // Kandidaten-Positionen: Wo gibt es Abweichungen?
    const variablePositions: number[] = positionCodes
      .map((codes, i) => ({ i, set: new Set(codes) }))
      .filter(entry => entry.set.size > 1)
      .map(entry => entry.i);

    // Alle Positionen kombinieren und prüfen, ob bis auf einen alle systematisch variieren
    const scorePerIndex = Array(n).fill(0);

    for (const pos of variablePositions) {
      const values = positionCodes[pos];
      const deltas = values.map((val, i) => i === 0 ? 0 : val - values[i - 1]);

      // Mehrheits-Delta berechnen
      const majorityDelta = this.getMajorityDelta(deltas.slice(1)); // slice(1) da erstes Delta 0 ist

      // Erwartete Werte berechnen basierend auf Mehrheitsdelta
      const expectedValues = values.map((_, i) => values[0] + i * majorityDelta);

      // Abweichungen zählen
      for (let i = 0; i < n; i++) {
        if (values[i] !== expectedValues[i]) {
          scorePerIndex[i]++;
        }
      }
    }

    // Der Index mit den meisten Abweichungen (sollte genau 1 sein)
    const maxScore = Math.max(...scorePerIndex);
    const candidates = scorePerIndex.map((s, i) => (s === maxScore ? i : -1)).filter(i => i !== -1);

    return candidates.length === 1 ? candidates[0] : undefined;
  }

  getMajorityDelta(deltas: number[]): number {
    const freq = new Map<number, number>();
    for (const d of deltas) {
      freq.set(d, (freq.get(d) ?? 0) + 1);
    }
    const sorted = [...freq.entries()].sort((a, b) => b[1] - a[1]);
    return sorted[0][0]; // häufigstes Delta
  }

  sortByCellNumbers(rawSceneData: Array<RawSceneDataItem>): Array<RawSceneDataItem> {

    const hasCellNumber = rawSceneData.some(item => {
      return item?.a?.Cell !== undefined;
    })


    if (!hasCellNumber) {
      return rawSceneData;
    }

    function parseCell(cellValue: string): number {
      const ss = cellValue.split(",")
      const num = parseInt(ss[0]) * 10 + (ss.length > 1 ? parseInt(ss[1]) : 0);
      return num;
    }

    return rawSceneData.sort((itemA, itemB) => {
      const cellA = itemA?.a?.Cell ? parseCell(itemA.a.Cell) : 0;
      const cellB = itemB?.a?.Cell ? parseCell(itemB.a.Cell) : 0;
      return cellA - cellB;
    });
  }

  knxBuildSceneInfos(channels: Array<Channel>) {
    channels.forEach((channel) => {
      let rawSceneData = sortArrayByIntProperty(channel.rawSceneData, "index");
      rawSceneData = this.sortByCellNumbers(rawSceneData);


      logger.log(
        `knxBuildSceneInfos for channel  ${channel.name}  #rawSceneData=${rawSceneData?.length}`,
        rawSceneData,
      );

      const numberItemIndexes = this.findSceneNumberItemIndexes(rawSceneData);
      let activationIndexes = this.findSceneActivationIndexes(rawSceneData, 0);


      const activationStrings: string[] = [];
      for (let i = 0; i < activationIndexes.length; i++) {
        const item = rawSceneData[activationIndexes[i]];
        activationStrings.push(item.a.Name);
      }

      //
      // Stelle fest,
      // ob es ein globales SceneActivationItem gibt,
      // oder ob es nur individuelle SceneActivationItems gibt.
      // die individuelle SceneActivationItems 
      //
      let deviceUsesGlobalSceneActivation = activationIndexes.length == 1 ?
        activationIndexes[0] :
        this.findOutlierWithSystematicPattern(activationStrings)


      if (deviceUsesGlobalSceneActivation !== undefined) {

        // 
        // we have a global scene activation item
        //
        console.log("deviceUsesGlobalSceneActivation", deviceUsesGlobalSceneActivation, activationStrings[deviceUsesGlobalSceneActivation]);

        this.setGlobalScenesEnableingId(rawSceneData, channel);
        activationIndexes.shift(); // remove the global activation item

      } else {
        console.log("NO deviceUsesGlobalSceneActivation");
      }



      if (activationIndexes.length > 0) {
        for (let i = 0; i < activationIndexes.length; i++) {
          let a = activationIndexes[i];
          const aNext = activationIndexes[i + 1] || rawSceneData.length;

          let item = rawSceneData[a++];

          const sceneInfo = new KnxSceneInfo();
          sceneInfo.instanceId = item.instanceId;
          sceneInfo.moduleId = item.moduleId;

          channel.knxSceneInfos.knxSceneInfos.push(sceneInfo);

          sceneInfo.activateId = item.id;

          if (a < aNext) {
            item = rawSceneData[a++];
            if (!this.knxProductData.isSceneNumberItem(item)) {
              logger.devError("knxBuildSceneInfos: expected SceneNumberItem", item);
            } else {
              sceneInfo.numberId = item.id;
            }
          }


          this.attachBehavioursToSceneInfo(sceneInfo, rawSceneData, a, aNext - 1)
        }
      } else {
        for (let i = 0; i < numberItemIndexes.length; i++) {
          let n = numberItemIndexes[i];
          const nNext = numberItemIndexes[i + 1] || rawSceneData.length;

          let item = rawSceneData[n++];

          const sceneInfo = new KnxSceneInfo();
          sceneInfo.instanceId = item.instanceId;
          sceneInfo.moduleId = item.moduleId;

          channel.knxSceneInfos.knxSceneInfos.push(sceneInfo);

          sceneInfo.numberId = item.id;

          this.attachBehavioursToSceneInfo(sceneInfo, rawSceneData, n, nNext - 1)
        }
      }

    }); // for each channel
  }


  setGlobalScenesEnableingId(rawSceneData: Array<RawSceneDataItem>, channel: Channel): boolean {

    //
    // we allow only the first item to be the "channelSceneEnabling" Property
    //
    const firstItem = rawSceneData[0];
    if (firstItem) {
      if (channel.knxSceneInfos.channelSceneEnablingId && channel.knxSceneInfos.channelSceneEnablingId != firstItem.id) {
        logger.devError("findChannelScenesEnableingId: channelSceneEnablingId already set", channel.knxSceneInfos.channelSceneEnablingId, firstItem.id);
      } else {
        channel.knxSceneInfos.channelSceneEnablingId = firstItem.id;
        channel.knxSceneInfos.channelSceneEnablingInstanceId = firstItem.instanceId;
        channel.knxSceneInfos.channelSceneEnablingModuleId = firstItem.moduleId;
        return true;
      }
    }
    return false;
  }



}